import axiosInstance from "./axios.instance";

export const layDanhSachKhuVuc = async (lichSu: boolean = false) => {
  return axiosInstance.get(`KhuVuc?lichSu=${lichSu}`) as any;
};

export const themMoiKhuVuc = async (body: any[]) => {
  return axiosInstance.post(`KhuVuc`, body);
};
